<template>
    <div class="designerpage">

        <senator-designer-question-door-range v-if="range_panel_required"
                                               :fabricator="fabricator"
                                               v-model:target="door.attr.door_range"
                                               :ranges="ranges"
                                               title="Please select a Door Collection"
                                               :defaults="defaults()"
                                               :reference_on="reference_on"></senator-designer-question-door-range>

        <div>
            <designer-question-select-door :fabricator="fabricator"
                                              :secured-by-design="door.attr.secured_by_design"
                                              :door-range="door.attr.door_range"
                                              v-model:target="door.attr.slab"></designer-question-select-door>

            <!--<designer-question-frame-material :slab="door.attr.slab"-->
                                                 <!--:fabricator="fabricator"-->
                                                 <!--v-model:target="door.attr.frame_material"></designer-question-frame-material>-->
        </div>

        <designer-question-steel-inserts v-if="door.attr.door_range == 124" :fabricator="fabricator"
                                         :slab="door.attr.slab"
                                         v-model:target="door.attr.steel_inserts"
        ></designer-question-steel-inserts>

        <div class="designeroption">
            <designer-question-hinge-side :fabricator="fabricator"
                                          v-model:target="door.attr.hinge_side"></designer-question-hinge-side>
        </div>

        <div class="designeroption">
            <designer-question-opening-direction v-show="technical_should_show" :fabricator="fabricator"
                                                 v-model:target="door.attr.opening_direction"
                                                 :frame-combination="door.attr.frame_style.frame_id"></designer-question-opening-direction>
        </div>

        <designer-question-select-frame-style :fabricator="fabricator"
                                                       :is-firedoor="is_firedoorrange"
                                                       v-model:target="door.attr.frame_style"></designer-question-select-frame-style>

        <div class="designeroption" data-designer-component-id="door_colour">
            <h3>Choose Your Door Colour</h3>

            <div class="colourtabs">
                <ul>
                    <li><a href="#dc-tabs-1">External Colour</a></li>
                    <li><a href="#dc-tabs-2">Internal Colour</a></li>
                </ul>
                <div id="dc-tabs-1">
                    <designer-question-door-colour-external :fabricator="fabricator" :slab="door.attr.slab"
                                                               :door-range="door.attr.door_range"
                                                               :colour-range="door.attr.colour_range"
                                                               v-model:target="door.attr.external_colour"></designer-question-door-colour-external>

                    <!--<designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.external_colour"-->
                                                  <!--title="External Door Colour"-->
                                                  <!--v-model:target="door.attr.external_colour_ral"></designer-question-ral-colour>-->
                </div>
                <div id="dc-tabs-2">
                    <designer-question-door-colour-internal :fabricator="fabricator" :slab="door.attr.slab"
                                                               :external-colour="door.attr.external_colour"
                                                               :door-range="door.attr.door_range"
                                                               :colour-range="door.attr.colour_range"
                                                               v-model:target="door.attr.door_colour_internal"></designer-question-door-colour-internal>

                    <!--<designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.door_colour_internal"-->
                                                  <!--title="Internal Door Colour"-->
                                                  <!--v-model:target="door.attr.door_colour_internal_ral"></designer-question-ral-colour>-->
                </div>
            </div>
        </div>

        <div class="designeroption" data-designer-component-id="frame_colour">
            <h3>Pick Your Frame Colour</h3>

            <div class="colourtabs">
                <ul>
                    <li><a href="#tabs-1">External Colour</a></li>
                    <li><a href="#tabs-2">Internal Colour</a></li>
                </ul>
                <div id="tabs-1">
                    <designer-question-frame-colour-external :fabricator="fabricator"
                                                                :frame-material="door.attr.frame_material"
                                                                :slab="door.attr.slab"
                                                                :profile="door.attr.profile"
                                                                :door-range="door.attr.door_range"
                                                                v-model:target="door.attr.frame_colour_external"></designer-question-frame-colour-external>

                    <!--<designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.frame_colour_external"-->
                                                  <!--title="External Frame Colour"-->
                                                  <!--v-model:target="door.attr.frame_colour_external_ral"></designer-question-ral-colour>-->
                </div>
                <div id="tabs-2">
                    <designer-question-frame-colour-internal :fabricator="fabricator"
                                                                :frame-colour-external="door.attr.frame_colour_external"
                                                                :slab="door.attr.slab"
                                                                :profile="door.attr.profile"
                                                                :door-range="door.attr.door_range"
                                                                v-model:target="door.attr.frame_colour_internal"></designer-question-frame-colour-internal>

                    <!--<designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.frame_colour_internal"-->
                                                  <!--title="Internal Frame Colour"-->
                                                  <!--v-model:target="door.attr.frame_colour_internal_ral"></designer-question-ral-colour>-->
                </div>
            </div>
        </div>

        <!--<div v-show="technical_should_show">-->
            <!--<designer-question-secured-by-design-->
                    <!--:fabricator="fabricator"-->
                    <!--v-model:target="door.attr.secured_by_design"-->
            <!--&gt;</designer-question-secured-by-design>-->

            <!--<designer-question-door-glass-laminated :fabricator="fabricator"-->
                                                    <!--title="Laminated Glass:"-->
                                                    <!--:slab="door.attr.slab"-->
                                                    <!--:frame-style="door.attr.frame_style"-->
                                                    <!--:side-panels="door.attr.side_panels"-->
                                                    <!--:secured-by-design="door.attr.secured_by_design"-->
                                                    <!--:is-firedoor="is_firedoorrange"-->
                                                    <!--:collection="door.attr.collection"-->
                                                    <!--v-model:target="door.attr.laminated_glass"></designer-question-door-glass-laminated>-->
        <!--</div>-->

        <div>
            <senator-designer-question-glass-design :fabricator="fabricator"
                                               v-model:target="door.attr.glass_design"
                                               :laminated-glass="door.attr.laminated_glass"
                                               :door-range="door.attr.door_range"
                                               :slab="door.attr.slab"></senator-designer-question-glass-design>
        </div>

        <designer-question-glass-backing-design :fabricator="fabricator"
                                                   v-model:target="door.attr.glass_backing_design"
                                                   :slab="door.attr.slab"
                                                   :door-range="door.attr.door_range"
                                                   :glass-design="door.attr.glass_design"></designer-question-glass-backing-design>

      <senator-designer-question-select-frame-sidepanels :fabricator="fabricator"
                                                          v-model:target="door.attr.side_panels"
                                                          :door-range="door.attr.door_range"
                                                          :frame-style="door.attr.frame_style"
                                                          :frame-profile="door.attr.profile"
                                                          :frame-material="door.attr.frame_material"
                                                          :laminated-glass="door.attr.laminated_glass"
                                                          :frame-colour-internal="door.attr.frame_colour_internal"
                                                          :frame-colour-external="door.attr.frame_colour_external"
                                                          :secured-by-design="door.attr.secured_by_design"
                                                          :slab="door.attr.slab"
                                                          :measurements.sync="door.attr.measurements"
                                                          :glass-design="door.attr.glass_design"
                                                          :backing-glass="door.attr.glass_backing_design"
                                                          :solid_slab="solid_slab"
      ></senator-designer-question-select-frame-sidepanels>

      <designer-question-hardware-colour :fabricator="fabricator"
                                         v-model:target="door.attr.hardware_colour"
                                         :sbd="door.attr.secured_by_design"
                                         :slab="door.attr.slab"
                                         :door-range="door.attr.door_range"
                                         :profile="door.attr.profile"
                                         :opening-direction="door.attr.opening_direction"
                                         :title="'Hardware Colour (Select your hardware colour to see your options in that colour)'"
      ></designer-question-hardware-colour>
        <div>
          <designer-question-hardware-handle :fabricator="fabricator"
                                             v-model:target="door.attr.hardware_handle"
                                             :slab="door.attr.slab"
                                             :secured-by-design="door.attr.secured_by_design"
                                             :opening-direction="door.attr.opening_direction"
                                             :hardware-colour="door.attr.hardware_colour"
                                             :door-range="door.attr.door_range"
                                             :profile="door.attr.profile"></designer-question-hardware-handle>

            <!--<designer-question-hardware-handle-split-spindle v-show="technical_should_show" :fabricator="fabricator"-->
                                                             <!--v-model:target="door.attr.hardware_handle_split_spindle"-->
                                                             <!--:hardware-handle="door.attr.hardware_handle"-->
                                                             <!--:opening-direction="door.attr.opening_direction"-->
                                                             <!--:slab="door.attr.slab"></designer-question-hardware-handle-split-spindle>-->

            <!--<designer-question-hardware-handle-internal :fabricator="fabricator"-->
                                                        <!--v-model:target="door.attr.hardware_handle_internal"-->
                                                        <!--:slab="door.attr.slab"-->
                                                        <!--:secured-by-design="door.attr.secured_by_design"-->
                                                        <!--:opening-direction="door.attr.opening_direction"-->
                                                        <!--:hardware-colour="door.attr.hardware_colour"-->
                                                        <!--:door-range="door.attr.door_range"-->
                                                        <!--:profile="door.attr.profile"-->
                                                        <!--:handle-external="door.attr.hardware_handle"></designer-question-hardware-handle-internal>-->

            <div v-if="!is_firedoorrange">
                <designer-question-hardware-decorative-handle :fabricator="fabricator"
                                                              v-model:target="door.attr.hardware_decorative_handle"
                                                              :slab="door.attr.slab"
                                                              :hardware-colour="door.attr.hardware_colour"
                                                              :door-range="door.attr.door_range"></designer-question-hardware-decorative-handle>

                <designer-question-hardware-decorative-handle-position :fabricator="fabricator"
                                                                       v-model:target="door.attr.hardware_decorative_handle_pos"
                                                                       :slab="door.attr.slab"
                                                                       :frame-material="door.attr.frame_material"
                                                                       :hardware-decorative-handle="door.attr.hardware_decorative_handle"></designer-question-hardware-decorative-handle-position>
            </div>
        </div>
        <div>
            <designer-question-hardware-escutcheon :fabricator="fabricator"
                                                      v-model:target="door.attr.hardware_escutcheon"
                                                      :slab="door.attr.slab"
                                                      :secured-by-design="door.attr.secured_by_design"
                                                      :hardware-colour="door.attr.hardware_colour"
                                                      :hardware-handle="door.attr.hardware_handle"
                                                      :door-range="door.attr.door_range"
                                                      :profile="door.attr.profile"></designer-question-hardware-escutcheon>

            <designer-question-hardware-escutcheon-position :fabricator="fabricator"
                                                            v-model:target="door.attr.hardware_escutcheon_pos"
                                                            :slab="door.attr.slab"
                                                            :frame-material="door.attr.frame_material"
                                                            :hardware-escutcheon="door.attr.hardware_escutcheon"></designer-question-hardware-escutcheon-position>
        </div>
        <div v-show="technical_should_show">
            <designer-question-hardware-lock :fabricator="fabricator"
                                             v-model:target="door.attr.hardware_lock"
                                             :secured-by-design="door.attr.secured_by_design"
                                             :hinge-side="door.attr.hinge_side"
                                             :slab="door.attr.slab"
                                             :frame-material="door.attr.frame_material"
                                             :hardware-handle="door.attr.hardware_handle"
                                             :opening_direction="door.attr.opening_direction"
                                             :hardware-escutcheon="door.attr.hardware_escutcheon"
                                             :door-range="door.attr.door_range"
                                             :maintitle="'Choose Your Lock'"
            ></designer-question-hardware-lock>

            <!--<designer-question-hardware-cylinder v-show="technical_should_show" :fabricator="fabricator"-->
                                                    <!--title="Choose Your Cylinder"-->
                                                    <!--:slab="door.attr.slab"-->
                                                    <!--v-model:target="door.attr.hardware_cylinder"-->
                                                    <!--:secured-by-design="door.attr.secured_by_design"-->
                                                    <!--:hardware-lock="door.attr.hardware_lock"-->
                                                    <!--:hardware-colour="door.attr.hardware_colour"-->
                                                    <!--:opening_direction="door.attr.opening_direction"-->
                                                    <!--:hardware-handle="door.attr.hardware_handle"-->
                                                    <!--:collection="door.attr.collection"-->
                                                    <!--:door-range="door.attr.door_range"></designer-question-hardware-cylinder>-->
        </div>

        <div>
            <senator-designer-question-hardware-letterbox v-if="door.attr.door_range != 124" :fabricator="fabricator"
                                                     v-model:target="door.attr.hardware_letterbox"
                                                     :secured-by-design="door.attr.secured_by_design"
                                                     :slab="door.attr.slab"
                                                     :side-panels="door.attr.side_panels"
                                                     :frame-id="door.attr.frame_style.frame_id"
                                                     :hardware-handle="door.attr.hardware_handle"
                                                     :hardware-colour="door.attr.hardware_colour"
                                                     :door-range="door.attr.door_range"
                                                     :decorative-handle="door.attr.hardware_decorative_handle"
            ></senator-designer-question-hardware-letterbox>

            <!--<designer-question-hardware-letterbox-cowl :fabricator="fabricator"-->
                                                       <!--v-model:target="door.attr.hardware_letterbox_cowl"-->
                                                       <!--:secured-by-design="door.attr.secured_by_design"-->
                                                       <!--:hardware-letterplate="door.attr.hardware_letterbox"-->
                                                       <!--:hardware-colour="door.attr.hardware_colour"></designer-question-hardware-letterbox-cowl>-->

            <senator-designer-question-hardware-letterbox-position :fabricator="fabricator"
                                                           v-model:target="door.attr.hardware_letterbox_pos"
                                                           :slab="door.attr.slab"
                                                           :side-panels="door.attr.side_panels"
                                                           :frame-id="door.attr.frame_style.frame_id"
                                                           :frame-material="door.attr.frame_material"
                                                           :hardware-letterbox="door.attr.hardware_letterbox"
                                                           :decorative-position="door.attr.hardware_decorative_handle_pos"
            ></senator-designer-question-hardware-letterbox-position>
        </div>
        <div>
            <designer-question-hardware-knocker v-if="door.attr.door_range != 124" :fabricator="fabricator"
                                                   v-model:target="door.attr.hardware_knocker"
                                                   :slab="door.attr.slab"
                                                   :hardware-handle="door.attr.hardware_handle"
                                                   :hardware-spyhole="door.attr.hardware_spy_hole"
                                                   :hardware-colour="door.attr.hardware_colour"
                                                   :door-range="door.attr.door_range"></designer-question-hardware-knocker>

            <designer-question-hardware-knocker-position v-if="door.attr.door_range != 124" :fabricator="fabricator"
                                                         v-model:target="door.attr.hardware_knocker_pos"
                                                         :slab="door.attr.slab"
                                                         :frame-material="door.attr.frame_material"
                                                         :hardware-knocker="door.attr.hardware_knocker"></designer-question-hardware-knocker-position>
        </div>
        <div>
            <designer-question-hardware-spy-hole v-if="door.attr.door_range != 124" :fabricator="fabricator"
                                                 :title="'Hardware Spyhole'"
                                                    v-model:target="door.attr.hardware_spy_hole"
                                                    :slab="door.attr.slab"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :glass-design="door.attr.glass_design"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :hardware-knocker="door.attr.hardware_knocker"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :door-range="door.attr.door_range"></designer-question-hardware-spy-hole>

            <designer-question-hardware-spy-hole-position v-if="door.attr.door_range != 124" :fabricator="fabricator"
                                                          v-model:target="door.attr.hardware_spy_hole_pos"
                                                          :slab="door.attr.slab"
                                                          :frame-material="door.attr.frame_material"
                                                          :hardware-spy-hole="door.attr.hardware_spy_hole"></designer-question-hardware-spy-hole-position>
        </div>
        <!--<div class="designeroption" v-show="technical_should_show" data-designer-component-id="numerals">-->
            <!--<designer-question-hardware-numerals :fabricator="fabricator"-->
                                                 <!--v-model:target="door.attr.numerals"-->
                                                 <!--:slab="door.attr.slab"-->
                                                 <!--:hardware-handle="door.attr.hardware_handle"-->
                                                 <!--:hardware-colour="door.attr.hardware_colour"-->
                                                 <!--title="Numerals"></designer-question-hardware-numerals>-->
        <!--</div>-->
        <div v-show="technical_should_show">
            <!--<designer-question-hardware-hinge :fabricator="fabricator"-->
                                                 <!--v-model:target="door.attr.hardware_hinge"-->
                                                 <!--:slab="door.attr.slab"-->
                                                 <!--:opening_direction="door.attr.opening_direction"-->
                                                 <!--:secured-by-design="door.attr.secured_by_design"-->
                                                 <!--:hardware-colour="door.attr.hardware_colour"-->
                                                 <!--:hinge-side="door.attr.hinge_side"-->
                                                 <!--:frame-material="door.attr.frame_material"-->
                                                 <!--:door-range="door.attr.door_range"></designer-question-hardware-hinge>-->

            <!--<div class="designeroption">-->
                <!--<designer-question-hardware-hinge-bolts v-if="!is_firedoorrange"-->
                                                                 <!--:fabricator="fabricator"-->
                                                                 <!--v-model:target="door.attr.hardware_hinge_bolts"-->
                                                                 <!--:hardware-hinge="door.attr.hardware_hinge"-->
                                                                 <!--:secured-by-design="door.attr.secured_by_design"-->
                                                                 <!--:hardware-colour="door.attr.hardware_colour"></designer-question-hardware-hinge-bolts>-->
            <!--</div>-->

            <!--<designer-question-hardware-security-chain :fabricator="fabricator"-->
                                                       <!--:secured-by-design="door.attr.secured_by_design"-->
                                                       <!--v-model:target="door.attr.hardware_security_chain"-->
                                                       <!--:hardware-colour="door.attr.hardware_colour"-->
                                                       <!--:door-range="door.attr.door_range"></designer-question-hardware-security-chain>-->
        <!--</div>-->

        <!--<div v-if="is_firedoorrange">-->
            <!--<designer-question-closer :fabricator="fabricator"-->
                                      <!--v-model:target="door.attr.closer"></designer-question-closer>-->
        <!--</div>-->

        <!--<div v-show="technical_should_show">-->
            <!--<designer-question-technical-profile :fabricator="fabricator"-->
                                                 <!--:frame-colour-internal="door.attr.frame_colour_internal"-->
                                                 <!--:frame-colour-external="door.attr.frame_colour_external"-->
                                                 <!--:frame-material="door.attr.frame_material"-->
                                                 <!--:secured-by-design="door.attr.secured_by_design"-->
                                                 <!--:hardware-handle="door.attr.hardware_handle"-->
                                                 <!--:hardware-escutcheon="door.attr.hardware_escutcheon"-->
                                                 <!--v-model:target="door.attr.profile"-->
                                                 <!--:maintitle="'Select your frame profile & size'"-->
                                                 <!--:title="''"-->
            <!--&gt;</designer-question-technical-profile>-->
        <!--</div>-->

        <div v-show="technical_should_show">
            <designer-question-measurements title="Enter Your Required Measurements"
                                                     :fabricator="fabricator"
                                                     :slab="door.attr.slab"
                                                     :external-colour="door.attr.external_colour"
                                                     :internal-colour="door.attr.door_colour_internal"
                                                     :frame-profile="door.attr.profile"
                                                     :threshold="door.attr.threshold"
                                                     :frame-id="door.attr.frame_style.frame_id"
                                                     :side-panels="door.attr.side_panels"
                                                     :addons="door.attr.addons"
                                                     :cill="door.attr.cill"
                                                     :hardware-lock="door.attr.hardware_lock"
                                                     :hardware-hinge="door.attr.hardware_hinge"
                                                     :hardware-handle="door.attr.hardware_handle"
                                                     :hardware-knocker="door.attr.hardware_knocker"
                                                     :hardware-spy-hole="door.attr.hardware_spy_hole"
                                                     :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                     :hardware-letterbox="door.attr.hardware_letterbox"
                                                     :hardware-letterbox-position="door.attr.hardware_letterbox_pos"
                                                     :mdd="mdd"
                                                     :technical_should_show="technical_should_show"
                                                     v-model:target="door.attr.measurements"></designer-question-measurements>
        </div>

        <!--<div v-show="technical_should_show">-->
            <!--<designer-question-addons :fabricator="fabricator"-->
                                         <!--v-model:target="door.attr.addons"-->
                                         <!--:frame-profile="door.attr.profile"-->
                                         <!--:frame-colour-internal="door.attr.frame_colour_internal"-->
                                         <!--:frame-colour-external="door.attr.frame_colour_external">-->

            <!--</designer-question-addons>-->
        <!--</div>-->

        <!--<div v-show="technical_should_show">-->
            <!--<designer-question-technical-threshold :fabricator="fabricator"-->
                                                      <!--title="Choose Your Threshold"-->
                                                      <!--v-model:target="door.attr.threshold"-->
                                                      <!--:frame-colour-internal="door.attr.frame_colour_internal"-->
                                                      <!--:frame-colour-external="door.attr.frame_colour_external"-->
                                                      <!--:opening-direction="door.attr.opening_direction"-->
                                                      <!--:frame-profile="door.attr.profile"-->
                                                      <!--:door-range="door.attr.door_range"-->
                                                      <!--:secured-by-design="door.attr.secured_by_design"></designer-question-technical-threshold>-->

        <!--</div>-->

        <div class="designeroption" v-show="technical_should_show">
            <h3>Select Any Required Cills</h3>
            <designer-question-technical-cill :fabricator="fabricator"
                                              v-model:target="door.attr.cill"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :opening-direction="door.attr.opening_direction"
                                              :frame-profile="door.attr.profile"
                                              :door-range="door.attr.door_range"
                                              :threshold="door.attr.threshold"
                                              :component_id="'cill'"
            ></designer-question-technical-cill>

            <designer-question-technical-cill v-if="left_flag_sill" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.left_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              :title="'Left Sidepanel Flag'"
                                              :component_id="'left_flag_cill'"
            ></designer-question-technical-cill>

            <designer-question-technical-cill v-if="right_flag_sill" :fabricator="fabricator"
                                              v-model:target="door.attr.side_panels.right_flag_sill_id"
                                              :frame-colour-internal="door.attr.frame_colour_internal"
                                              :frame-colour-external="door.attr.frame_colour_external"
                                              :frame-profile="door.attr.profile"
                                              :title="'Right Sidepanel Flag'"
                                              :component_id="'right_flag_cill'"
            ></designer-question-technical-cill>
        </div>

        <div>
            <designer-question-door-drip-colour v-show="technical_should_show" :fabricator="fabricator"
                                                   title="Choose A Door Drip colour"
                                                   :external-colour="door.attr.external_colour"
                                                   v-model:target="door.attr.door_drip_colour"
                                                   :frame-profile="door.attr.profile"
                                                   :door-range="door.attr.door_range"></designer-question-door-drip-colour>
        </div>

        <!--<div v-show="technical_should_show">-->

            <!--<designer-question-technical-drainage :fabricator="fabricator"-->
                                                     <!--v-model:target="door.attr.drainage"-->
                                                     <!--:cill="door.attr.cill"-->
                                                     <!--:threshold="door.attr.threshold"-->
                                                     <!--title="Choose your Drainage type"></designer-question-technical-drainage>-->
        <!--</div>-->

        <div class="designeroption" v-if="reference_on" data-designer-component-id="reference">
            <h3>Enter A Door Reference</h3>
            <div class="stylesoption">
                <div class="form-group">
                    <input dusk="door_reference" type="text" v-model="door.attr.reference" class="form-control">
                </div>
            </div>
        </div>
        <input v-else dusk="door_reference" type="hidden" v-model="door.attr.reference" class="form-control"
               value="Retail Door">

        <div class="designeroption" data-designer-component-id="notes">
            <designer-question-notes v-model:target="door.attr.notes"></designer-question-notes>
        </div>

    </div>

    <designer-navigation
            v-if="show_navigation"
            :visible_designer_configurator_components="visible_designer_configurator_components"
            transition="designer-navigation"
    ></designer-navigation>
    </div>

</template>

<script type="text/ecmascript-6">
    import DoorConfigurator from "../DoorConfigurator.vue";

    export default {
        mixins: [
            DoorConfigurator
        ],
        computed: {
            is_firedoorrange() {
                return this.door_type === 'fire';
            },
            solid_slab() {
              var solid_slabs = [2055,2059,2029,1809,1812,1826,1832];
              return solid_slabs.indexOf(this.door.attr.slab) !== -1;
            }
        },
        methods: {
          defaults() {
            return {
              106: {
                "attr": {
                  "fabricator": 25,
                  "door_range": 106,
                  "frame_colour_external": 1,
                  "door_colour_internal": 1,
                  "door_drip_colour": 11,
                  "external_colour": 11,
                  "frame_colour_internal": 1,
                  "frame_material": 1,
                  "hardware_colour": 22,
                  "hardware_handle": 2337,
                  "hardware_hinge": 2383,
                  "hinge_side": 1,
                  "opening_direction": 1,
                  "secured_by_design": 1,
                  "slab": 1808,
                  "frame_style": {"frame_id": 1, "checkedPanels": []},
                  "laminated_glass": 1,
                  "hardware_lock": 2381,
                  "hardware_cylinder": 2382,
                  "hardware_security_chain": 317,
                  "hardware_letterbox": 318,
                  "hardware_knocker": 315,
                  "hardware_suite": 78,
                  "hardware_spy_hole": 2379,
                  "profile": 177249,
                  "threshold": 177250,
                  "side_panels": {
                    "left": 1,
                    "right": 1,
                    "left_composite_id": null,
                    "right_composite_id": null,
                    "top_panel_glass_id": 9,
                    "left_composite_glass_id": null,
                    "right_composite_glass_id": null,
                    "left_panel_glass_id": 9,
                    "right_panel_glass_id": 9,
                    "lower_sidepanel_type": 3
                  },
                  "numerals": [326, 326, 326, 326],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                  "cill": 177252,
                  "drainage": 2,
                  "notes": "",
                  "measurements": {"overall_width": null, "overall_height": null, "left_width": null, "right_width": null, "top_box_drop": null},
                  "hardware_decorative_handle": 1112,
                  "glass_design": 1,
                  "hardware_spy_hole_pos": 408404,
                  "reference": "Retail Door"
                }
              },
              124: {
                "attr": {
                    "fabricator": 25,
                    "door_range": 124,
                    "frame_colour_external": 1,
                    "door_colour_internal": 1,
                    "door_drip_colour": 951,
                    "external_colour": 951,
                    "frame_colour_internal": 1,
                    "frame_material": 1,
                    "hardware_colour": 15,
                    "hardware_handle": 2666,
                    "hardware_hinge": 2383,
                    "hinge_side": 1,
                    "opening_direction": 1,
                    "secured_by_design": 1,
                    "slab": 2057,
                    "frame_style": {
                        "frame_id": 1,
                        "checkedPanels": []
                    },
                    "laminated_glass": 1,
                    "hardware_lock": 2381,
                    "hardware_cylinder": 2382,
                    "hardware_security_chain": 317,
                    "hardware_letterbox": 318,
                    "hardware_knocker": 315,
                    "hardware_suite": 78,
                    "hardware_spy_hole": 316,
                    "profile": 177249,
                    "threshold": 177250,
                    "side_panels": {
                        "left": 1,
                        "right": 1,
                        "left_composite_id": null,
                        "right_composite_id": null,
                        "top_panel_glass_id": 9,
                        "left_composite_glass_id": null,
                        "right_composite_glass_id": null,
                        "left_panel_glass_id": 9,
                        "right_panel_glass_id": 9
                    },
                    "numerals": [
                        326,
                        326,
                        326,
                        326
                    ],
                    "addons": {
                        "left": {},
                        "right": {},
                        "top": {},
                        "bottom": {},
                    },
                    "cill": 177252,
                    "drainage": 2,
                    "notes": "",
                    "measurements": {
                        "overall_width": null,
                        "overall_height": null,
                        "left_width": null,
                        "right_width": null,
                        "top_box_drop": null
                    },
                    "glass_design": 1,
                    "reference": "Retail Door",
                    "hardware_escutcheon_pos": 448302
                }
              },
            }
          },
        },
    }
</script>
